function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2403",
  "data-name": "Group 2403",
  transform: "translate(0 0.062)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_220",
  "data-name": "Group 220",
  transform: "translate(0 0.847)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_8",
  "data-name": "Group 8",
  transform: "translate(2.562)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_7",
  "data-name": "Group 7"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_14",
  "data-name": "Path 14",
  d: "M1193.8,6.205l-3.631-3.645a1.518,1.518,0,0,0-1.073-.439h-6.913a1.5,1.5,0,0,0-1.5,1.505l-.006,8.07a2.855,2.855,0,0,1,.711-.084,3.061,3.061,0,0,1,3.063,3.062,2.939,2.939,0,0,1-.174,1.015h8.464a1.517,1.517,0,0,0,1.505-1.512V7.265A1.481,1.481,0,0,0,1193.8,6.205Zm-9.355-1.073h1.809a.756.756,0,0,1,0,1.512h-1.809a.756.756,0,0,1,0-1.512Zm0,2.876h3.024a.756.756,0,0,1,0,1.512h-3.024a.756.756,0,0,1,0-1.512ZM1189,12.543h-4.548a.753.753,0,0,1,0-1.505H1189a.753.753,0,1,1,0,1.505Zm.73-5.15a.76.76,0,0,1-.756-.749V3.253l4.148,4.141Z",
  transform: "translate(-1180.68 -2.122)",
  fill: "rgba(125,158,241,0.8)"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_66",
  "data-name": "Path 66",
  d: "M1179.452,18.145a2.737,2.737,0,1,0,2.737,2.737A2.738,2.738,0,0,0,1179.452,18.145Zm1.662,2.2-.014.016h0l-1.6,1.752a.517.517,0,0,1-.731.019l-.019-.019-.948-1.047a.518.518,0,0,1,.02-.725.5.5,0,0,1,.7.008l.012.013.593.644,1.224-1.348a.494.494,0,0,1,.7-.032l.013.012A.5.5,0,0,1,1181.114,20.342Z",
  transform: "translate(-1176.714 -7.793)",
  fill: "rgba(125,158,241,0.8)"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_119",
  "data-name": "Rectangle 119",
  width: 17,
  height: 17,
  transform: "translate(0 -0.062)",
  fill: "none"
}));

var SvgRequiredDocuments = function SvgRequiredDocuments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRequiredDocuments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/required-documents.3758b080.svg";
export { ForwardRef as ReactComponent };